/** @format */

import React, { useState } from 'react';
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TableContainer,
  CardActions,
  InputAdornment,
} from '@mui/material';
import { InputV, BusinessList, SimpleDialog , Icons, InputCurrency} from 'components';
import { useFieldArray, useFormContext } from 'react-hook-form';

const Beneficiary = (props) => {
  const { classes } = props;

  const methods = useFormContext();

  const defaultValues = {
    businessName: '',
    fixedShareAmount: '',
    percentage: '',
    discountSharePercent: '',
  };

  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: 'scStakeholderList',
  });

  const add = () => {
    append(defaultValues);
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [indexSelected, setIndexSelected] = useState(-1);
  const removeRow = (index) => {
    setIndexSelected(index);
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button onClick={confirmRemove} variant="contained" color="primary">
          تایید
        </Button>
        <Button onClick={closeDialog} variant="contained">
          انصراف
        </Button>
      </>
    );
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const confirmRemove = () => {
    setOpenDialog(false);
    remove(indexSelected);
    setIndexSelected(-1);
  };

  return (
    <>
      <SimpleDialog
        title="حذف ذینفع"
        content="آیا از حذف اطمینان دارید؟"
        open={openDialog}
        actions={<ActionsBtn />}
      />
      <Grid container direction="row" alignItems="center" spacing={4}>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>ردیف</TableCell>
                  <TableCell align="center">نام کسب‌وکار</TableCell>
                  <TableCell align="center">مبلغ تسهیم</TableCell>
                  <TableCell align="center">درصد تسهیم</TableCell>
                  <TableCell align="center">درصد تخفیف</TableCell>
                  <TableCell align="center">عملیات</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fields.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell component="th" scope="row" style={{ width: 320 }}>
                      <BusinessList
                        name={`scStakeholderList[${index}].businessId`}
                        errors={methods.formState.errors}
                        control={methods.control}
                        defaultValue={row.businessId}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <InputCurrency
                        errors={methods.formState.errors}
                        name={`scStakeholderList[${index}].fixedShareAmount`}
                        register={methods.register}
                        rules={['required']}
                        fullWidth
                        control={methods.control}
                        defaultValue={row.fixedShareAmount}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <InputV
                        errors={methods.formState.errors}
                        name={`scStakeholderList[${index}].percentage`}
                        register={methods.register}
                        rules={['required']}
                        fullWidth
                        control={methods.control}
                        defaultValue={row.percentage}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <InputV
                        errors={methods.formState.errors}
                        name={`scStakeholderList[${index}].discountSharePercent`}
                        register={methods.register}
                        // rules={["required"]}
                        fullWidth
                        control={methods.control}
                        defaultValue={row.discountSharePercent}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        variant="contained"
                        color="primary"
                        aria-label="delete"
                        onClick={() => removeRow(index)}
                        size="large">
                         <Icons icon="Trash" color="#2b3990" size="20" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item xs={12}>
          <CardActions>
            <Button color="primary" variant="contained" aria-label="add" onClick={add}>
              افزودن
            </Button>
          </CardActions>
        </Grid>
      </Grid>
    </>
  );
};

export default Beneficiary;
